var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMic = function SvgMic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.656 13.53c0 .26.21.47.469.47h3.75a.469.469 0 0 0 0-.938h-3.75a.47.47 0 0 0-.469.468",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 14c.259 0 .469-.21.469-.47v-1.687a.469.469 0 1 0-.938 0v1.687c0 .26.21.47.469.47",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.781 8.093A4.223 4.223 0 0 0 8 12.312a4.223 4.223 0 0 0 4.219-4.22.469.469 0 0 0-.938 0A3.286 3.286 0 0 1 8 11.375a3.286 3.286 0 0 1-3.281-3.281.469.469 0 0 0-.938 0",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.656 8.093a2.344 2.344 0 1 0 4.688 0v-3.75a2.344 2.344 0 0 0-4.688 0zM8 9.499c-.777 0-1.406-.63-1.406-1.406v-3.75a1.406 1.406 0 1 1 2.812 0v3.75c0 .777-.63 1.406-1.406 1.406M4.25 6.687c.259 0 .469-.21.469-.47V5.28a.469.469 0 0 0-.938 0v.938c0 .259.21.469.469.469M2.469 7.624c.259 0 .469-.21.469-.469V4.343a.469.469 0 0 0-.938 0v2.812c0 .26.21.47.469.47M11.75 6.687c.259 0 .469-.21.469-.47V5.28a.469.469 0 0 0-.938 0v.938c0 .259.21.469.469.469M13.531 7.624c.26 0 .469-.21.469-.469V4.343a.469.469 0 0 0-.937 0v2.812c0 .26.21.47.468.47",
    clipRule: "evenodd"
  })));
};
export { SvgMic as ReactComponent };
export default __webpack_public_path__ + "bbb45262b2aefaeaa1ce002072d190ce.svg";